"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarSep = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../styles/context");
const context_2 = require("../../context");
const h = React.createElement;
const separatorClass = (0, nano_theme_1.rule)({
    w: '4px',
    h: '24px',
    pd: 0,
    mr: 0,
});
const ToolbarSep = ({ line, thick, height, lite, compact }) => {
    const styles = (0, context_1.useStyles)();
    const subtle = (0, context_2.useSubtleTrace)();
    const props = {
        className: separatorClass,
    };
    if (line) {
        props.style = {
            width: thick ? '2px' : '1px',
            height: height ?? (subtle ? '18px' : void 0),
            margin: compact ? '0 2px' : '0 4px',
            background: styles.g(0, lite ? 0.06 : 0.16),
        };
    }
    return h('div', props);
};
exports.ToolbarSep = ToolbarSep;
